"use strict";
var _StateInstance_isTransitioning, _StateInstance_stateName, _StateInstance_factory;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateInstance = void 0;
const tslib_1 = require("tslib");
const symbols_1 = require("./symbols");
/**
 * Represents a state instance.
 */
class StateInstance {
    constructor(factory, name, props, isTransitioning = false) {
        _StateInstance_isTransitioning.set(this, false);
        _StateInstance_stateName.set(this, void 0);
        _StateInstance_factory.set(this, void 0);
        tslib_1.__classPrivateFieldSet(this, _StateInstance_stateName, name, "f");
        tslib_1.__classPrivateFieldSet(this, _StateInstance_isTransitioning, isTransitioning, "f");
        tslib_1.__classPrivateFieldSet(this, _StateInstance_factory, factory, "f");
        return Object.freeze(Object.assign(this, props));
    }
    get [(_StateInstance_isTransitioning = new WeakMap(), _StateInstance_stateName = new WeakMap(), _StateInstance_factory = new WeakMap(), symbols_1.isTransitioningSym)]() {
        return tslib_1.__classPrivateFieldGet(this, _StateInstance_isTransitioning, "f");
    }
    set [symbols_1.isTransitioningSym](val) {
        tslib_1.__classPrivateFieldSet(this, _StateInstance_isTransitioning, val, "f");
    }
    get [symbols_1.stateNameSym]() {
        return tslib_1.__classPrivateFieldGet(this, _StateInstance_stateName, "f");
    }
    get [Symbol.toStringTag]() {
        return this[symbols_1.stateNameSym];
    }
    static clone(state, changedProps) {
        return tslib_1.__classPrivateFieldGet(state, _StateInstance_factory, "f").call(state, { ...state, ...changedProps });
    }
}
exports.StateInstance = StateInstance;
//# sourceMappingURL=state-type.js.map